<template>
  <v-dialog persistent v-model="show" max-width="500px">
    <v-card ref="form">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Confirm Action!</h3>

        </div>
      </v-card-title>

      <v-card-text>
        <h4>{{confirmMessage}}</h4>
        <br>
        <div style="font-size:18px;">To confirm, retype <div class="noselect" style="color:#ff0f00;">{{confirmString}}</div> exactly as shown below.</div>
        <v-text-field
          ref="typedString"
          v-model="typedString"
          :rules="[v => v === confirmString || 'Confirm text does not match!']"
          :error-messages="errorMessages"
          label="Confirm Text"
          placeholder=""
          required
        ></v-text-field>
      </v-card-text>

      <v-card-actions>
        <v-btn color="primary" @click.native="close">Cancel Action</v-btn>
        <v-btn :disabled="matches" color="error" @click.native="confirmAction">Confirm Action</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
  import generator from 'generate-password'

  export default {
    name: "CreateUserDialog",
    props: {
      confirmString: "",
      actionType: "",
      confirmMessage: "",
      visible: {
        type: Boolean
      }
    },
    data() {
      return {
        formHasErrors: false,
        typedString: '',
        username: '',
        errorMessages: [],
        permissions: []
      }
    },
    computed: {

      matches() {
        return this.confirmString !== this.typedString;
      },
      show: {
        get() {
          this.typedString = "";
          return this.visible
        },
        set(value) {
          if (!value) {
            this.$emit('close')
          }
        }
      }
    },
    methods: {
      close(){
        this.$emit('close')
      },
      confirmAction() {
        if(this.confirmString === this.typedString){
          this.$emit('confirmed', {actionType: this.actionType, confirmString: this.confirmString});
        }
      }
    }
  }
</script>

<style scoped>
  .noselect {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
  }
</style>



// WEBPACK FOOTER //
// src/components/dialogs/HighRiskConfirmDialog.vue